import React from 'react';

interface Props {
  children: React.ReactNode;
}

export default function Grid3Layout({ children }: Props) {
  return <div className="w-full grid grid-cols-3 items-start gap-x-8 gap-y-8 ">{children}</div>;
}
